import { render, staticRenderFns } from "./UserDetailInfo.vue?vue&type=template&id=7f258350&scoped=true&"
import script from "./UserDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./UserDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailInfo.vue?vue&type=style&index=0&id=7f258350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f258350",
  null
  
)

export default component.exports